import React from "react";
import { useState, useContext } from "react";
import "../Login/LogInPage.css";
import AuthContext from "../store/auth-context";

function Reset(props) {
  const [email, setEmail] = useState("");
  const authCtx = useContext(AuthContext);

  function emailHandler(event) {
    setEmail(event.target.value);
  }
  function takeMeToSignUpHandler() {
    props.signUp();
  }
  function takeMeToSignInHandler() {
    props.signIn();
  }
  function submitHandler(event) {
    event.preventDefault();
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyCRmLhkduKgXPMyxhjPHlDXwLwv8AZ4_m8",
      {
        method: "POST",
        body: JSON.stringify({
          requestType: "PASSWORD_RESET",
          email: email,
        }),
        header: {
          "Content/type": "application/json",
        },
      }
    ).then((res) => {
      if (res.ok) {
        authCtx.setErrorMessage("Email Sent (Check Your Junk)!");
        takeMeToSignInHandler();
      } else {
        authCtx.setErrorMessage("Email Not Found!");
      }
    });
  }
  return (
    <>
      <div>
        <form className="signInForm" onSubmit={submitHandler}>
          <h1 class="loginTitle"> Reset Password!</h1>
          <br></br>
          <div class="form-group">
            <label for="exampleInputEmail1" class="formSub">
              Email address
            </label>
            <input
              type="email"
              onChange={emailHandler}
              class="form-control emailInput"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter email"
            ></input>
          </div>
          <div>
            <a
              id="emailHelp"
              class="form-text text-muted formSub "
              onClick={takeMeToSignUpHandler}
              href="#"
            >
              Sign Up instead here!{" "}
            </a>
            <a
              id="emailHelp"
              class="form-text text-muted formSub"
              onClick={takeMeToSignInHandler}
            >
              Sign In instead here!
            </a>
            <br></br>
            {/* <a id="emailHelp" class="form-text text-muted formSub" onClick={takeMeToResetPassword}>Forgot Password</a>  */}
          </div>
          <br></br>

          <button type="submit" class="btn btn-primary submitButton">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default Reset;
